import React from 'react';
import {Col, Row} from 'react-bootstrap';
import SimpleCard from './Card/SimpleCard';

const DashboardCardLayout = ({row, col, content, className, cardClassName, loading, loaderElement}) => {
  const rows = Array.from({length: row}, (_, index) => content.slice(index * col, (index + 1) * col));
  return (
    <div className={className}>
      {rows.map((rowContent, rowIndex) => (
        <Row key={rowIndex}>
          {rowContent.map((data, colIndex) => (
            <Col className={cardClassName} key={colIndex}>
              <SimpleCard
                className={cardClassName}
                data={data}
                loaderElement={loaderElement}
                loading={loading}
              />
            </Col>
          ))}
        </Row>
      ))}
    </div>
  );
};

export default DashboardCardLayout;
